module.exports = __webpack_public_path__ + "static/img/img2.236b365d.png";